import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()
export interface ChildBanks {
  childId: string
  code: string
  action: string
  childBankId?: string
  parentBankId?: string
  customFields: any
}
export interface BankSucursals {
  bankId?: string
  name: string
  code: string
  action: string
}
export interface Banks {
  countryId: string
  code: string
  name: string
  address1: string
  address2: string
  childBanks: ChildBanks[]
  sucursals: BankSucursals[]
}

export async function getBanks(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id=:countryId']
  if (search) {
    where.push(`CONCAT(name,code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END), code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_banks'],
    fields: ['id', 'name', 'code', 'is_inactive', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getBank(id: string): Promise<Banks> {
  const data = await getData<any>({
    tables: ['pg_banks'],
    fields: [
      'country_id as countryId',
      'id',
      'code',
      'name',
      'address_1 as address1',
      'address_2 as address2',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createBank(data: Banks): Promise<boolean> {
  for (const childBank of data.childBanks) {
    childBank.customFields = {
      ...getCustomProps(childBank)
    }
  }
  const response: any = await http.post('/country/banks', {
    countryId: data.countryId,
    name: data.name,
    code: data.code,
    address1: data.address1,
    address2: data.address2,
    childBanks: data.childBanks,
    sucursals: data.sucursals,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateBank(data: Banks, id: string): Promise<boolean> {
  for (const childBank of data.childBanks) {
    delete childBank.childBankId
    delete childBank.parentBankId
    childBank.customFields = {
      ...getCustomProps(childBank)
    }
  }

  for (const sucursal of data.sucursals) {
    delete sucursal.bankId
  }

  const response: any = await http.put('/country/banks/' + id, {
    countryId: data.countryId,
    name: data.name,
    code: data.code,
    address1: data.address1,
    address2: data.address2,
    childBanks: data.childBanks,
    sucursals: data.sucursals,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateBank(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(`/country/banks/${id}/enable/`, {
    enable
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteBank(id: string): Promise<boolean> {
  const response: any = await http.delete('/country/banks/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
